<template>
  <div class="inscription-page">
    <div class="inscription-card">
      <b-overlay
        :show="inLoad"
        variant="white"
        rounded
        opacity="0.70"
        spinner-variant="primary"
        spinner-small
      >
        <div class="inscription-header">
          <div class="inscription-badge">
            <b-icon icon="house-door" scale="1.4" class="inscription-icon"></b-icon>
          </div>
          <div class="inscription-kicker">Espace client ITTEC P&M</div>
          <h2 class="inscription-title">Inscription</h2>
          <p class="inscription-subtitle">Créez votre compte pour suivre vos demandes, devis et commandes dans un espace plus simple.</p>
        </div>

        <div class="inscription-content">
          <Societes :addClt=true></Societes>
        </div>

        <b-collapse id="collapse-4" v-model="loginError" class="mt-2 inscription-error">
          Erreur d'authentification, veuillez vérifier vos codes
        </b-collapse>
      </b-overlay>
    </div>
  </div>
</template>
<script>
const Societes = () => import(/* webpackChunkName: "common" */ "@/pages/societes/index.vue");
import Vue from "vue";
import {SuperAdminRouter, AgentRouter, ClientRouter} from "@/router/initRouter";
export default {
  components: {
    Societes
  },
  props: {
    withCid: {
      type: Boolean,
      default: () => {
        return false;
      },
    }
  },
  data() {
    return {
      loginFiled: '',
      pwdFiled: '',
      loginError: false,
      inLoad : false,
      requireAuth : false,
    };
  },
  methods: {

    
  },
  mounted() {
    //Vue.$cookies.remove("user")
    //this.checkAndGo()
  }
};
</script>
<style scoped>
.inscription-page {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  min-height: calc(100vh - 190px);
  padding: 48px 16px 72px;
}

.inscription-card {
  width: 100%;
  max-width: 880px;
  background: linear-gradient(180deg, #ffffff 0%, #f7faff 100%);
  border-radius: 30px;
  border: 1px solid #dce5f0;
  box-shadow: 0 30px 60px rgba(15, 23, 42, 0.12);
  overflow: hidden;
}

.inscription-header {
  text-align: center;
  padding: 34px 36px 28px;
  border-bottom: 1px solid #e5ebf3;
  background:
    linear-gradient(135deg, rgba(245, 157, 42, 0.16) 0%, rgba(245, 157, 42, 0.02) 36%, transparent 36%),
    linear-gradient(-35deg, rgba(245, 157, 42, 0.16) 0%, rgba(245, 157, 42, 0.02) 34%, transparent 34%),
    linear-gradient(135deg, #ffffff 0%, #f8fbff 100%);
}

.inscription-badge {
  width: 72px;
  height: 72px;
  margin: 0 auto 12px;
  border-radius: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  background: linear-gradient(135deg, #f59d2a 0%, #f1851b 100%);
  box-shadow: 0 16px 30px rgba(241, 133, 27, 0.26);
}

.inscription-kicker {
  color: #6d7b93;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  margin-bottom: 8px;
}

.inscription-icon {
  color: inherit;
}

.inscription-title {
  font-size: 40px;
  font-weight: 700;
  color: #1e2a44;
  margin: 0 0 8px;
}

.inscription-subtitle {
  color: #61728f;
  font-size: 15px;
  line-height: 1.6;
  margin: 0 auto;
  max-width: 620px;
}

.inscription-content {
  padding: 28px 36px 36px;
}

.inscription-content :deep(.societePage) {
  margin: 0 !important;
}

.inscription-content :deep(.form-section) {
  margin-bottom: 20px;
  padding: 20px 22px;
  border: 1px solid #e4ebf3;
  border-radius: 22px;
  background: linear-gradient(180deg, #fbfdff 0%, #f3f7fb 100%);
}

.inscription-content :deep(.form-section-accent) {
  margin-left: 0;
  margin-right: 0;
  padding: 22px;
  border-radius: 22px;
  background: linear-gradient(180deg, #fff7ef 0%, #fff2e3 100%);
  border: 1px solid #f6d5b4;
}

.inscription-content :deep(.form-section-title) {
  font-size: 18px;
  font-weight: 700;
  color: #1e2a44;
}

.inscription-content :deep(.form-label) {
  font-size: 13px;
  font-weight: 700;
  color: #5f6f8b;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.inscription-content :deep(.form-control),
.inscription-content :deep(.custom-select) {
  min-height: 50px;
  border-radius: 14px !important;
  border-color: #d8e1ec;
  font-size: 15px;
}

.inscription-content :deep(.btn-inscription) {
  min-height: 52px;
  border-radius: 14px;
  box-shadow: 0 14px 30px rgba(241, 133, 27, 0.22);
}

.inscription-error {
  color: #dc3545;
  text-align: center;
  padding: 12px 14px;
  background: #fff5f5;
  border: 1px solid #f3c5c5;
  border-radius: 14px;
  margin: 0 36px 28px;
}

@media (max-width: 768px) {
  .inscription-page {
    padding: 22px 12px 56px;
  }
  .inscription-card {
    border-radius: 24px;
  }
  .inscription-header {
    padding: 26px 18px 22px;
  }
  .inscription-title {
    font-size: 30px;
  }
  .inscription-content {
    padding: 20px 16px 24px;
  }
  .inscription-error {
    margin: 0 16px 20px;
  }
}

@media (max-width: 480px) {
  .inscription-title {
    font-size: 24px;
  }
}
</style>
